<template>
    <div class="main">
        <div class="headWrap">
            <div class="leftWrap">
                <div class="text">PRODUCTS</div>
                <div class="dash"></div>
            </div>
            <div class="pathWrap">
                <div class="static">PRODUCTS &nbsp;>&nbsp; </div>
                <div class="category" @click="toPage(this.content[this.nowProduct]['backTo'])">{{ this.content[this.nowProduct]["category"] }}</div>
                <div class="static"> &nbsp;>&nbsp; </div>
                <div class="productName">{{ this.content[this.nowProduct]["productName"] }}</div>
            </div>
        </div>
        <div class="main_content">
            <div class="textContentWrap">
                <div class="productName" :style="{color: productNameColor}">{{ this.content[this.nowProduct]["mainTitle"] }}</div>
                <div class="title">Details</div>
                <div class="detailsContentWrap" v-for="item, index in this.content[this.nowProduct]['datails']" :key="`detail-${index}`">
                    <div class="dot" :style="{backgroundColor: productNameColor}"></div>
                    <div class="detail">{{ item }}</div>
                </div>
                <div class="title">Ingredients</div>
                <div class="ingredients">{{ this.content[this.nowProduct]["ingredients"] }}</div>
                <div class="title">Packaging</div>
                <div class="packaging">{{ this.content[this.nowProduct]["packaging"] }}</div>
                
                <!-- Desktop Left / Mobile Instructions -->
                <div class="title show-desktop-left-mobile" v-if="this.content[this.nowProduct]['instructionsPosition'] == 'left' || this.isMobile()">Instructions</div>
                <div class="instructions show-desktop-left-mobile" v-if="this.content[this.nowProduct]['instructionsPosition'] == 'left' || this.isMobile()">{{ this.content[this.nowProduct]["instructions"] }}</div>
                <img class="instructionsPic show-desktop-left-mobile" @click="handleImageClick(this.content[this.nowProduct]['instructionsPicPath'])" :style="{width: instructionsPicWidth}" v-if="(this.content[this.nowProduct]['instructionsPosition'] == 'left' || this.isMobile()) && this.content[this.nowProduct]['instructionsPicPath'] != ''" :src="this.content[this.nowProduct]['instructionsPicPath']" alt="">
                
                <div class="title">Precautions</div>
                <div class="precautions">{{ this.content[this.nowProduct]["precautions"] }}</div>
            </div>
            <div class="picArea" :style="{width: picWidth, marginRight: picMarginRight}">
                <div class="img-container" @click="handleImageClick(this.content[this.nowProduct]['picPath'])">
                    <img class="productPic" :src="this.content[this.nowProduct]['picPath']" alt="">
                    <div class="zoom-hint show-desktop-left-mobile">
                        <span>Click to zoom</span>
                    </div>
                </div>
                
                <!-- Desktop Right Only Instructions -->
                <div class="title hide-mobile" v-if="this.content[this.nowProduct]['instructionsPosition'] == 'right'">Instructions</div>
                <div class="instructions hide-mobile" v-if="this.content[this.nowProduct]['instructionsPosition'] == 'right'">{{ this.content[this.nowProduct]["instructions"] }}</div>
                <img class="instructionsPic hide-mobile" :style="{width: instructionsPicWidth}" v-if="this.content[this.nowProduct]['instructionsPosition'] == 'right' && this.content[this.nowProduct]['instructionsPicPath'] != ''" :src="this.content[this.nowProduct]['instructionsPicPath']" alt="">
            </div>
        </div>
        <!-- <div class="buttonWrap" @mouseenter="buttonActive()" @mouseleave="buttoDeactive()">
            <img ref="arrowIcon" src="../assets/product_detail/back_icon.webp" alt="">
            <div class="text">BACK TO OVERVIEW</div>
        </div> -->
        <div class="buttonWrap" @mouseenter="buttonActive()" @mouseleave="buttoDeactive()" @click="toPage(this.content[this.nowProduct]['backTo'])">
            <div class="picWrap" id="buttonPicWrap">
                <img class="buttonPic" id="buttonPic" src="../assets/product_detail/back_icon_hover.webp" alt="">
            </div>
            <div class="text">BACK TO OVERVIEW</div>
        </div>

        <div class="image-modal" v-if="showBigImage" @click="showBigImage = false">
             <img :src="bigImagePath" alt="" @click.stop>
             <div class="close-btn" @click="showBigImage = false">×</div>
        </div>

        <page-footer></page-footer>
    </div>
    
</template>

<script>
import PageFooter from "./PageFooter.vue";

export default {
    components: {
        PageFooter,
    },

    data() {
        return {
            nowProduct: "healthcare_0",
            mobileMenuOpen: false,
            showBigImage: false,
            bigImagePath: "",
            screenWidth: window.innerWidth,
            content:{
                healthcare_0: {
                    category: "HEALTHCARE",
                    productName: "Dr. TEST Hematuria/Blood Detector",
                    mainTitle: "Dr. TEST Hematuria/Blood Detector",
                    mainTitleColor: "#003F9D",
                    datails: [
                        "Detect cat urine blood and urine occult blood for early detection of urinary problems and for review and follow-up during recovery from urinary tract disorders.",
                        "When the particles contact the hemoglobin in cat urine, the color will turn blue. Cat urine occult blood is closely related to over 30 diseases that affect their health. Early detection enables timely intervention, treatment and a better prognosis.",
                        "An easy, hassle-free way to monitor the cat's urinary health at home. Whether you're concerned about urinary tract infections, bladder issues, or other health concerns, it provides peace of mind with minimal effort.",
                        "Keep your cat healthy and happy with the Dr.TEST Hematuria/Blood Detector-the simple, stress-free solution for proactive pet care.",
                    ],
                    ingredients: "Multiple types of cellulose, pre-gelatinized starch, chromogenic reagent.",
                    packaging: "10 g/pack, 10 packs/box",
                    instructions: "1. Sprinkle the test particles evenly onto the surface of the cat litter.\n\
                                2. Observe the color change of the particles after the cat urinates.\n\
                                3. The recommended observation time is within 4 hours after urination.\n\
                                4. Consult a veterinarian if blue appears.",
                    instructionsPosition: "left",
                    instructionsPicPath: "",
                    instructionsPicWidth: "",
                    precautions: "Product is for cat litter, do not ingest. \n\
                                This product is not a substitute for a medical examination.\n\
                                Always consult a veterinarian. \n\
                                Keep out of reach of children.",
                    picPath: require("../assets/product_detail/healthcare/0.webp"),
                    picWidth: "59%",
                    picMarginRight: "0",
                    backTo: "/products/healthcare"

                },
                healthcare_3: {
                    category: "HEALTHCARE",
                    productName: "Felizone Cat Pheromone Diffuser",
                    mainTitle: "Felizone Cat Pheromone Diffuser",
                    mainTitleColor: "#00A8EA",
                    datails: [
                        "Powered by pheromones, it mimics the feline facial pheromone that cats use to mark places, objects, and persons as familiar.",
                        "Sends kitty calming signals into the environment, it helps boost your cat's mood and helps reduce stress-induced behaviors.",
                        "Create a more comfortable environment for your cat and help reducing scratching, urine marking, and excessive meowing caused by stress and fear.",
                        "Relax your cat quickly without sedation, drug free.",
                    ],
                    ingredients: "Feline pheromone analogue·········································· 3%\n\
                                \n\
                                Isoparaffinic hydrocarbon·································· to 48 mL",
                    packaging: "48 mL per bottle with an electrical plug",
                    instructions: "Plug into a standard electrical socket in a vertical position where the cat spends the most time. Each refill bottle (48 mL) lasts up to 30 days and covers up to 70 square meters. Avoid plugging in the diffuser under shelves and furniture, or behind doors, curtains and furniture.\n\
                                \n\
                                Use consistently and replace the refill every 30 days and the plug every 6 months.",
                    instructionsPosition: "left",
                    instructionsPicPath: "",
                    instructionsPicWidth: "",
                    precautions: "For cats only.\n\
                                Avoid contact with eyes.\n\
                                Keep out of reach of children.\n\
                                Call a physician if you feel unwell and seek medical advice.",
                    picPath: require("../assets/product_detail/healthcare/3.webp"),
                    picWidth: "59%",
                    picMarginRight: "0",
                    backTo: "/products/healthcare"
                },
                healthcare_4: {
                    category: "HEALTHCARE",
                    productName: "Felizone Cat Pheromone Spray",
                    mainTitle: "Felizone Cat Pheromone Spray",
                    mainTitleColor: "#00A8EA",
                    datails: [
                        "Powered by pheromones, it mimics the feline facial pheromone that cats use to mark places, objects, and persons as familiar.",
                        "Sends kitty calming signals into the environment, it helps boost your cat's mood and helps reduce stress-induced behaviors.",
                        "Create a more comfortable environment for your cat and help reduce scratching, urine marking, and excessive meowing caused by stress and fear.",
                        "Relax your cat quickly without sedation, at home or on the go.",
                    ],
                    ingredients: "Feline pheromone analogue·········································· 10%\n\
                                \n\
                                Isoparaffinic hydrocarbon····································· to 30 mL",
                    packaging: "30 mL/bottle",
                    instructions: "Begin application 15 minutes before the cat enters a stressful situation such as a cat bag, vet visits, traveling or a new cat arrives home; press and spray on areas touched by cats. Repeat application every 4-6 hour if necessary.",
                    instructionsPosition: "left",
                    instructionsPicPath: "",
                    instructionsPicWidth: "",
                    precautions: "Do not spray directly on cat.\n\
                                Keep out of reach of children. \n\
                                Keep away from heat, hot surfaces, sparks, open flames, and other ignition sources. \n\
                                Call a physician if you feel unwell and seek medical advise.",
                    picPath: require("../assets/product_detail/healthcare/4.webp"),
                    picWidth: "48%",
                    picMarginRight: "5rem",
                    backTo: "/products/healthcare"
                },
                healthcare_6: {
                    category: "HEALTHCARE",
                    productName: "Allerfre Cat Allergen Neutralizing Spray",
                    mainTitle: "Allerfre Cat Allergen Neutralizing Spray",
                    mainTitleColor: "#FFA301",
                    datails: [
                        "Allerfre Spray reduces environmental allergens from cat saliva, dander and hair, thereby alleviating the symptoms of human allergy to cats.",
                        "Fel d1 and Fel d4 allergens secreted in cat saliva are retained on cat hair with cat licking, transferred to the environment through hair and dander, and after reaching a certain concentration, are contacted by the human body causing allergic reactions.",
                        "Allerfre Spray adds lyophilized powder containing anti-Fel d1 and Fel d4 specific yolk antibodies, which effectively neutralize the allergens (Fel d1 and Fel d4) and reduce the allergic symptoms to cats.",
                        "lmproves cat-induced sneezing, runny or stuffy nose, itchy, red or watery eyes coughing or wheezing, rashes, redness or itching of the skin, etc.",
                    ],
                    ingredients: "Egg yolk antibody purification liquid, alkyl polyglycoside (APG), witch hazel extract, jojoba oil, pure water.",
                    packaging: "300 mL/bottle",
                    instructions: "Spray on areas and items where allergens are attached (e.g., litter pads, cages, sofas, mattresses, litter boxes, and pet hair). Spray daily, with key items sprayed 2-3 times per day.",
                    instructionsPosition: "left",
                    instructionsPicPath: "",
                    instructionsPicWidth: "",
                    precautions: "Keep out of reach of children.\n\
                                Avoid spraying in eyes.",
                    picPath: require("../assets/product_detail/healthcare/6.webp"),
                    picWidth: "40%",
                    picMarginRight: "5rem",
                    backTo: "/products/healthcare"
                },
                supplement_0: {
                    category: "SUPPLEMENTS",
                    productName: "Allerfre Cat Allergen Neutralizing Tablets",
                    mainTitle: "Allerfre Cat Allergen Neutralizing Tablets",
                    mainTitleColor: "#FFA301",
                    datails: [
                        "Allerfre Tablets reduces the release of allergens from the cat, thereby alleviating the symptoms of human allergy to cats.",
                        "Fel d1 and Fel d4 allergens secreted in cat saliva are retained on cat hair with cat licking, transferred to the environment through hair and dander, and after reaching a certain concentration, are contacted by the human body causing allergic reactions.",
                        "Allerfre Tablets adds lyophilized powder containing anti-Fel d1 and Fel d4 specific yolk antibodies, which effectively neutralize the allergens (Fel d1 and Fel d4), and block allergens form the source without altering the normal physiological function of cats.",
                        "Improves cat-induced sneezing, runny or stuffy nose, itchy, red or watery eyes, coughing or wheezing, rashes, redness or itching of the skin, etc.",
                    ],
                    ingredients: "Active Ingredients: Egg yolk powder (containing specific IgY)",
                    packaging: "The tablets are packaged in high-density polyethylene bottles, with 200 tablets per bottle.",
                    instructions: "Suitable for cats of all ages, can be fed directly or mixed with other foods.",
                    instructionsPosition: "left",
                    instructionsPicPath: require("../assets/product_detail/supplements/instructions/0.webp"),
                    instructionsPicWidth: "80%",
                    precautions: "For cat use only.\n\
                                Keep out of reach of children.",
                    picPath: require("../assets/product_detail/supplements/0.webp"),
                    picWidth: "44%",
                    picMarginRight: "0",
                    backTo: "/products/supplements"
                },
                supplement_1: {
                    category: "SUPPLEMENTS",
                    productName: "Allvita Intestinal Shield Paste",
                    mainTitle: "Allvita Intestinal Shield Paste",
                    mainTitleColor: "#F73247",
                    datails: [
                        "Intestinal Shield Paste helps regulating intestinal function and protecting the gastrointestinal mucosa.",
                        "Contains elm bark extract, a natural ingredient that quickly helps relieve diarrhea, helps repair and strengthen the mucosal barrier of the gastrointestinal tract, and gently stops vomiting.",
                        "Contains prebiotics (FOS&MOS) to help the colonization and growth of intestinal probiotics and balance intestinal flora.",
                        "Improves the symptoms of watery, mushy, soft, watery, mucous membrane and jelly stools, and relieves intestinal discomfort.",
                        "For dogs and cats with various intestinal problems, nutritional supplementation and soothing conditioning.",
                    ],
                    ingredients: "Active Ingredients: elm bark extract, fructooligosaccharide(FOS), mannan oligosaccharide (MOS), montmorillonite, glutamine.",
                    packaging: "The paste is packaged in a graduated applicator. Each applicator contains 30 ml, and each box contains one applicator.",
                    instructions: "Feeding on an empty stomach. Adjust the feeder scale, push out the paste, and feed directly.",
                    instructionsPosition: "right",
                    instructionsPicPath: require("../assets/product_detail/supplements/instructions/1.webp"),
                    instructionsPicWidth: "75%",
                    precautions: "Store in a cool, dry area out of direct sunlight.\n\
                                For dogs and cats only. Keep out of reach of children.\n\
                                This product is not a substitute for medication. If no improvement after 2 days of use, please consult your veterinarian for further assistance.",
                    picPath: require("../assets/product_detail/supplements/1.webp"),
                    picWidth: "44%",
                    picMarginRight: "0",
                    backTo: "/products/supplements"
                },
                supplement_2: {
                    category: "SUPPLEMENTS",
                    productName: "Allvita Urinary Support Tablets",
                    mainTitle: "Allvita Urinary Support Tablets",
                    mainTitleColor: "#F73247",
                    datails: [
                        "Urinary Support Tablets support pet’s normal urinary function.",
                        "Contains oligochitosan, cranberry extract, plantain powder, green tea crude extract, sodium hyaluronate, L-tryptophan and raspberry to support pet’s urinary tract health.",
                        "Helps conserving bladder mucosa and promoting smooth urination.",
                        "Helps preventing bad bacteria from attaching to the lining of pet’s bladder wall and promoting the elimination of harmful substances from the urinary tract with urine.",
                        "Tryptophan&Theanine can soothe emotions and reduce the incidence of urinary tract disorders due to stress.",
                    ],
                    ingredients: "Active Ingredients: chitosan oligosaccharide, sodium hyaluronate, green tea crude extract (theanine source), cranberry extract, plantain powder, L-tryptophan, raspberry powder.",
                    packaging: "The tablets are packaged in aluminum foil blister packs, with 3 blister packs per box, 30 tablets per box.",
                    instructions: "Feed (tablets) with food. More than 1 tablet per day needed, please feed separately in the morning and evening.",
                    instructionsPosition: "right",
                    instructionsPicPath: require("../assets/product_detail/supplements/instructions/2.webp"),
                    instructionsPicWidth: "100%",
                    precautions: "Store in a cool, dry area out of direct sunlight.\n\
                                For dogs and cats only. Keep out of reach of children.\n\
                                It is recommended not to feed below the guided dosage and to increase the daily water intake of your beloved pet. In case of accidental overdose, contact a health professional immediately.",
                    picPath: require("../assets/product_detail/supplements/1.webp"),
                    picWidth: "44%",
                    picMarginRight: "0",
                    backTo: "/products/supplements"
                },
                medicine_0: {
                    category: "MEDICINE",
                    productName: "NEXFLUR Fluralaner chewable tablet",
                    mainTitle: "NEXFLUR \nFluralaner chewable tablet",
                    mainTitleColor: "#FFA301",
                    datails: [
                        "NEXFLUR Chews for dogs is the longest-lasting chew for powerful fleas, ticks, and mites protection.",
                        "Fluralaner, an ectoparasiticide belonging to the isoxazoline group, is easily absorbed when ingested. It interferes with transmembrane signal transmission in the insect nervous system, leading to nervous system disorders and ultimately death.",
                        "NEXFLUR is indicated for the treatment of flea (Ctenocephalides felis), tick ([Ixodes scapularis (black-legged tick), Dermacentor variabilis (American dog tick), Rhipicephalus sanguineus (brown dog tick), Haemaphysalis longicornis (Asian longhorned tick), Amblyomma americanum (lone star tick)], and mite (Demodex and Sarcoptes) infestations in dogs.",
                        "NEXFLUR offers weight-adjusted chewable tablets. A highly palatable, easy-to-administer chewable formulation that starts to work within hours and provides lasting protection with just one quarterly dose.",
                        "Safe in breeding, pregnant and lactating dogs, puppies over 8 weeks and 2 kg, MDR-1 negative dogs, and other breeds sensitive to macrocyclic lactones.",
                    ],
                    ingredients: "Fluralaner",
                    packaging: "NEXFLUR is available in five strengths (112.5, 250, 500, 1000, and 1400 mg fluralaner per chew). Each chew is packaged individually into aluminum foil blister packs sealed with a peelable paper-backed foil film. Packaged in 1, 2, or 4 chews per box.",
                    instructions: "Oral use. The chewable tablets should be administered at intervals of 12 weeks. Dosages are as follows: (corresponding to a dose of 25-56 mg fluralaner/kg body weight within one weight band).",
                    instructionsPosition: "right",
                    instructionsPicPath: require("../assets/product_detail/medicine/instructions/0.webp"),
                    instructionsPicWidth: "100%",
                    precautions: "Do not store above 30℃. \n\
                                Should not be used on puppies less than 8 weeks old and /or dogs weighing less than 2 kg. \n\
                                Use with caution in dogs with pre-existing epilepsy. \n\
                                Should not be administered at intervals shorter than 8 weeks.",
                    picPath: require("../assets/product_detail/medicine/0.webp"),
                    picWidth: "44%",
                    picMarginRight: "0",
                    backTo: "/products/medicine"
                },
                medicine_1: {
                    category: "MEDICINE",
                    productName: "Moxispot Imidacloprid and Moxidectin Spot-on Solutions",
                    mainTitle: "Moxispot \nImidacloprid and Moxidectin Spot-on Solutions",
                    mainTitleColor: "#F73247",
                    datails: [
                        "Moxispot provides comprehensive monthly protection against both endoparasites and ectoparasites with a single topical application for dogs and cats.",
                        "Imidacloprid, a chloronicotinyl ectoparasiticide, disrupts insects’ CNS transmission and causes paralysis and death. Imidacloprid is rapidly distributed over the animal’s skin within one day of application. It can be found on the body surface throughout the treatment interval.",
                        "Moxidectin, a macrocyclic lactone, targets GABA and glutamate-gated chloride channels in parasites, inducing hyperpolarization, flaccid paralysis, and death. It demonstrates broad-spectrum efficacy against internal and external parasites. Moxidectin is distributed throughout the body within one month after administration and is slowly metabolized and excreted. Imidacloprid and moxidectin work together and have a synergistic effect.",
                        "Moxispot is indicated for The treatment and prevention of flea infestation (Ctenocephalides felis), biting lice (Trichodectes canis), ear mite infestation (Otodectes cynotis), sarcoptic mange (caused by Sarcoptes scabiei var. canis), demodicosis (caused by Demodex canis), heartworm disease (L3 and L4 larvae of Dirofilaria immitis), circulating microfilariae (Dirofilaria immitis), cutaneous dirofilariosis (Dirofilaria repens), angiostrongylosis (L4 larvae and immature adults of Angiostrongylus vasorum), Angiostrongylus vasorum and Crenosoma vulpis, spirocercosis (Spirocerca lupi), the eye worm Thelazia callipaeda, gastrointestinal nematodes (L4 larvae, immature adults and adults of Toxocara canis, Ancylostoma caninum and Uncinaria stenocephala, adults of Toxascaris leonina and Trichuris vulpis).",
                    ],
                    ingredients: "Imidacloprid, Moxidectin",
                    packaging: "Cardboard box containing a total of 1,2,3,6 unit dose pipettes. For dogs, each unit dose pipette contains 0.4 ml, 1.0 ml, 2.5 ml and 4.0 ml of solution. For cats, each unit dose pipette contains 0.4 ml and 0.8 ml of solution.",
                    instructions: "For external use only. One dose per 1 kg of body weight, 0.1 ml for dogs and cats. The product should be administered monthly.",
                    instructionsPosition: "right",
                    instructionsPicPath: require("../assets/product_detail/medicine/instructions/1.webp"),
                    instructionsPicWidth: "100%",
                    precautions: "Do not store above 25°C.\n\
                                Do not use in puppies under 7 weeks of age and kittens under 9 weeks of age.\n\
                                Do not use in cases of hypersensitivity to the active substances or to any of the excipients.\n\
                                Do not use in dogs classified as Class 4 for heartworm disease as the safety of the veterinary medicinal product has not been evaluated in this animal group.\n\
                                The treatment of animals weighing less than 1kg should be based on the guidance of a veterinarian.\n\
                                Use with caution in sick, debilitated, or underweight animals.\n\
                                Care should be taken that the veterinary medicinal product is not ingested by animals and does not come into contact with the eyes or mouth of the recipient and/or other animals.\n\
                                Do not allow recently treated animals to groom each other. Do not allow treated animals to come into contact with untreated animals until the application site is dry.",
                    picPath: require("../assets/product_detail/medicine/1.webp"),
                    picWidth: "44%",
                    picMarginRight: "0",
                    backTo: "/products/medicine"
                },
                medicine_2: {
                    category: "MEDICINE",
                    productName: "Deltashield Deltamethrin collar",
                    mainTitle: "Deltashield \nDeltamethrin collar",
                    mainTitleColor: "#F73247",
                    datails: [
                        "Deltashield is a collar impregnated with deltamethrin. Controls the dog paralysis tick (Ixodes holocyclus) for up to 3 months. Controls the brown dog tick (Rhipicephalus songuineus) for up to 6 months.",
                        "Deltamethrin is a synthetic pyrethroid insecticide. It is slowly and continuously released in low concentrations from the collar. Deltamethrin is not widely absorbed by dogs, but it can spread from the area of contact with the collar to the entire skin, providing at least six months of tick (Rhipicephalus sanguineus) protection.",
                        "The collar provides early protection for growing puppies (8+ weeks and older) with its puppy-friendly formula.",
                        "The adjustable sizing ensures a perfect fit for dogs of all breeds and weights, while the easy-snap application allows for quick, secure fastening in seconds - making protection both effortless and effective.",
                    ],
                    ingredients: "Deltamethrin",
                    packaging: "One collar is packed into a sachet made of paper-aluminum-polyethylene or paper-aluminum-polyester-polyethylene and secured in the outer carton.",
                    instructions: "For external use only. One collar per dog. Remove the collar from the sealed protective sachet. Adjust the collar around the animal’s neck without tightening it too tightly. Two fingers side-by-side should fit between the band and the dog’s neck. Slide the end through the buckle and cut off any excess length extending beyond 5 cm.",
                    instructionsPosition: "right",
                    instructionsPicPath: require("../assets/product_detail/medicine/instructions/2.webp"),
                    instructionsPicWidth: "90%",
                    precautions: "Store below 25°C. Protect from light.",
                    picPath: require("../assets/product_detail/medicine/2.webp"),
                    picWidth: "44%",
                    picMarginRight: "0",
                    backTo: "/products/medicine"
                },
            }
        }
    },

    computed: {
        productNameColor() {
            return this.content[this.nowProduct]['mainTitleColor']
        },
        picWidth() {
            return this.content[this.nowProduct]['picWidth']
        },
        picMarginRight() {
            return this.content[this.nowProduct]['picMarginRight']
        },
        instructionsPicWidth() {
            return this.content[this.nowProduct]['instructionsPicWidth']
        }
    },
    methods: {
        toPage(newPath) {
            this.$router.push(newPath)
        },

        buttonActive() {
            window.$('#buttonPic').css("left", "0")
        },
        buttoDeactive() {
            window.$('#buttonPic').css("left", "60.5%")
        },
        calculateHeight() {
            window.$('#buttonPicWrap').css("height", `${window.$('#buttonPic').height() / Number(window.$(":root").css("font-size").replace("px", ""))}rem`)
        },
        handleImageClick(path) {
            if (this.isMobile()) {
                this.bigImagePath = path;
                this.showBigImage = true;
            }
        },
        isMobile() {
            return this.screenWidth <= 768;
        }
    },

    mounted() {
        var that = this
        window.addEventListener('resize', () => {
            this.screenWidth = window.innerWidth
        })
        
        that.nowProduct = that.$route.path.match(/\/{1}[\w]*$/g)[0].slice(1,)
        // console.log("aaaa:", that.$route.path.match(/\/{1}[\w]*$/g)[0].slice(1,))
        this.$watch(
            () => this.$route.path,
            (newPath) => {
                that.nowProduct = newPath.match(/\/{1}[\w]*$/g)[0].slice(1,)
            }
        )
        // 此处是为了确保buttonPic图片加载完成后计算其外部容器高度，不然图片没加载完成就计算可能导致外部容器高度为0
        const img = document.querySelector('#buttonPic');
        if (img.complete) {
            this.calculateHeight();
        } else {
            img.onload = this.calculateHeight;
        }
        // window.$('#buttonPicWrap').css("height", `${window.$('#buttonPic').height() / Number(window.$(":root").css("font-size").replace("px", ""))}rem`)
    },
}
</script>

<style scoped lang="scss">
.main {
  padding-top: $navBarHeight;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.headWrap {
    width: 80%;
    display: flex;
    flex-direction: row;
    align-items: flex-end;
    justify-content: space-between;
    // padding: 0 $screenPadding;
    margin-top: 4.5rem;
    border-bottom: 1px solid #D8D8D8;
    padding-bottom: 0.6rem;

    .leftWrap {
        display: flex;
        flex-direction: column;
        align-items: center;

        .text {
            font-size: 1.5rem;
            font-weight: 500;
            color: #2C2B2B;
            font-family: "Montserrat", serif;
        }

        .dash {
            width: 100%;
            height: 0.3rem;
            background-color: $mainColor;
            margin-top: 0.4rem;
        }
    }

    .pathWrap {
        display: flex;
        flex-direction: row;
        white-space: pre;
        font-size: 1.2rem;
        font-weight: 500;
        font-family: "Montserrat", serif;
        padding-bottom: 0.2rem;

        .static {
            white-space: pre-wrap;
            color: #7F7F7F;
        }

        .category {
            color: #7F7F7F;
            cursor: pointer;
        }

        .productName {
            color: $mainColor;
        }
    }
}

.main_content {
    width: 80%;
    margin-top: 3rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    
    .textContentWrap {
        display: flex;
        flex-direction: column;
        max-width: 48%;
        
        .productName {
            font-size: 2.4rem;
            font-weight: 600;
            white-space: pre-line;
            // width: 40%;
        }

        .title {
            margin-top: 1.8rem;
            margin-bottom: 0.8rem;
            font-weight: 600;
            font-size: 1.3rem;
            color: #2C2B2B;
        }

        .detailsContentWrap {
            display: flex;
            flex-direction: row;
            margin-bottom: 1rem;

            .dot {
                width: 0.5rem;
                height: 0.5rem;
                border-radius: 50%;
                flex-shrink: 0;
                margin-right: 0.6rem;
                margin-top: 0.6rem;
            }

            .detail {
                font-size: 1.1rem;
                color: #646465;
                line-height: 1.6rem;
                font-weight: 500;
                padding-right: 4rem;
                font-family: "Montserrat", serif;
            }

        }

        .ingredients {
            font-size: 1.1rem;
            color: #646465;
            line-height: 1.6rem;
            font-weight: 500;
            padding-right: 4rem;
            white-space: pre-line;
            font-family: "Montserrat", serif;
        }

        .packaging {
            font-size: 1.1rem;
            color: #646465;
            line-height: 1.6rem;
            font-weight: 500;
            padding-right: 4rem;
            white-space: pre-line;
            font-family: "Montserrat", serif;
        }

        .instructions {
            font-size: 1.1rem;
            color: #646465;
            line-height: 1.6rem;
            font-weight: 500;
            padding-right: 4rem;
            white-space: pre-line;
            font-family: "Montserrat", serif;
        }

        .instructionsPic {
            padding-right: 4rem;
            padding-top: 1.8rem;
            white-space: pre-line;
        }

        .precautions {
            font-size: 1.1rem;
            color: #646465;
            line-height: 1.6rem;
            font-weight: 500;
            padding-right: 4rem;
            white-space: pre-line;
            font-family: "Montserrat", serif;
        }
    }

    .picArea {
        // width: 54%;

        .productPic {
            width: 100%;
            height: auto;
        }

        .title {
            margin-top: 1.8rem;
            margin-bottom: 0.8rem;
            font-weight: 600;
            font-size: 1.3rem;
            color: #2C2B2B;
        }

        .instructions {
            font-size: 1.1rem;
            color: #646465;
            line-height: 1.6rem;
            font-weight: 500;
            // padding-right: 1rem;
            white-space: pre-line;
            font-family: "Montserrat", serif;
        }

        .instructionsPic {
            // padding-right: 4rem;
            padding-top: 1.8rem;
            white-space: pre-line;
        }
    }
}

.buttonWrap {
    margin-top: 5rem;
    margin-bottom: 5rem;
    width: 80%;
    height: 5rem;
    background-color: #EEEEEE;
    transition: background-color 0.3s ease;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    &:hover {
        background-color: #FFE97D;
    }

    .picWrap {
        width: 2.3rem;
        // height: 0.6rem;
        margin-right: 3rem;
        position: relative;
        overflow: hidden;

        .buttonPic {
            position: absolute;
            width: 100%;
            height: auto;
            // height: 0.6rem;
            left: 60.5%;
            transition: left 0.3s ease;
        }
    }

    .text {
            font-size: 1.3rem;
            font-weight: 500;
            color: #2C2B2B;
        }

}

.zoom-hint {
    display: none;
}

.image-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0,0,0,0.9);
    z-index: 1000;
    display: flex;
    justify-content: center;
    align-items: center;
    
    img {
        max-width: 95%;
        max-height: 90%;
        object-fit: contain;
        background-color: #fff;
    }
    
    .close-btn {
        position: absolute;
        top: 2rem;
        right: 2rem;
        width: 3rem;
        height: 3rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        background-color: rgba(255,255,255,0.2);
        color: #fff;
        font-size: 2rem;
        cursor: pointer;
        z-index: 1001;
    }
}

@media (max-width: 768px) {
    .main {
        padding-top: 4rem;
        // padding-bottom: 2rem;
    }

    .headWrap {
        width: 90%;
        margin-top: 2rem;
        flex-direction: column;
        align-items: flex-start;
        padding-bottom: 1rem;
        
        .leftWrap {
            align-items: flex-start;
            margin-bottom: 0.5rem;
            
            .text {
                font-size: 1.2rem;
            }
        }
        
        .pathWrap {
            flex-wrap: wrap;
            font-size: 0.85rem;
            line-height: 1.4;
            white-space: normal;
            
            .static {
                white-space: normal;
            }
            
            .productName {
                // Ensure product name in breadcrumb doesn't overflow awkwardly
                display: inline;
            }
        }
    }
    
    .main_content {
        width: 90%;
        margin-top: 1.5rem;
        flex-direction: column;
        
        .textContentWrap {
            max-width: 100%;
            order: 2;
            
            .productName {
                font-size: 1.5rem;
                margin-bottom: 0.5rem;
                line-height: 1.3;
            }

            .title {
                font-size: 1.1rem;
                margin-top: 1.5rem;
                margin-bottom: 0.5rem;
            }
            
            .detailsContentWrap {
                margin-bottom: 0.8rem;
                
                .dot {
                    margin-top: 0.5rem;
                    width: 0.4rem;
                    height: 0.4rem;
                }

                .detail {
                    font-size: 0.95rem;
                    line-height: 1.5rem;
                    padding-right: 0;
                }
            } 
            
            .ingredients, .packaging, .instructions, .precautions {
                font-size: 0.95rem;
                line-height: 1.5rem;
                padding-right: 0;
            }

            .instructionsPic {
                padding-right: 0;
                padding-top: 1rem;
                width: 100% !important;
            }
        }
        
        .picArea {
            width: 100% !important;
            margin-right: 0 !important;
            margin-bottom: 2rem;
            order: 1;

            .title {
                font-size: 1.1rem;
                margin-top: 1.5rem;
            }

            .instructions {
                font-size: 0.95rem;
                line-height: 1.5rem;
            }

            .instructionsPic {
                padding-top: 1rem;
                width: 100% !important;
            }

            .img-container {
                position: relative;
                
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                

                .zoom-hint {
                    margin-top: 0.5rem;
                    span {
                        font-size: 0.8rem;
                        color: #999;
                        opacity: 0.7;
                    }
                }
            }
        }
    }
    
    .buttonWrap {
        width: 90%;
        margin-top: 3rem;
        margin-bottom: 2rem;
        height: 3.5rem;
        border-radius: 0.5rem;
        
        .text {
            font-size: 0.9rem;
        }
        
        .picWrap {
            width: 1.8rem;
            margin-right: 1rem;
            
            .buttonPic {
                // Reset position for mobile as hover doesn't work well
                left: 0 !important; 
            }
        }
    }

    .hide-mobile {
        display: none !important;
    }
}
</style>